module.exports = __webpack_public_path__ + "img/exportWordWhite.1903519b.svg";